export default {"src":"/_next/static/media/disc-wheels.072b1eaf.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};